import mime, {TypeMap} from 'mime';

export function overrideMimeTypes(overrides: { mimeType: string; extension: string[] }[]): void {
  const mimes: TypeMap = overrides.reduce((acc, e) => {
    acc[e.mimeType] = e.extension;
    return acc;
  }, {} as TypeMap);

  mime.define(mimes, true);
}
